import { QuestionType } from "api/landlord-surveys/types/questions";

export type ViewMode = "desktop" | "mobile";

export type Answers = Record<string, string | string[]>;

export const isAutoAdvanceType = (type: QuestionType) =>
  type === QuestionType.YES_NO || type === QuestionType.RADIO_GROUP;
